export const colorsList = [
  '#29B5E8',
  '#F0913E',
  '#51AB4F',
  '#E93942',
  '#1E7EA1',
  '#4DAC4A',
];
